import { createFileRoute, Outlet } from "@tanstack/react-router";

// Pathless layout mirroring `apps/api/src/routes/administration` without the module name in the
// address.
export const Route = createFileRoute("/_authenticated/_administration")({
  component: Outlet,
});
